/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';
import '../resources/offer';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "CreateOfferRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "creditLimitAmount": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "aprBps": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "holdRateBps": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "CreateOfferResponse": {
                "fields": {
                  "offer": {
                    "type": ".squareup.corporate_card.resources.Offer",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.CreateOfferRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.CreateOfferResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateOfferRequest @ squareup/corporate_card/service/create_offer.proto at 11:1
 */
export const CreateOfferRequest = $root.lookupType('squareup.corporate_card.service.CreateOfferRequest');
fixType(CreateOfferRequest, {
  merchantToken: {
    required: true
  },
  creditLimitAmount: {
    required: true
  },
  aprBps: {
    required: true
  },
  holdRateBps: {
    required: true
  }
});
Builder.createAndAttachToType(CreateOfferRequest);
/**
 * SOURCE CreateOfferResponse @ squareup/corporate_card/service/create_offer.proto at 33:1
 */
export const CreateOfferResponse = $root.lookupType('squareup.corporate_card.service.CreateOfferResponse');
fixType(CreateOfferResponse);
Builder.createAndAttachToType(CreateOfferResponse);